var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "md-switch",
        {
          attrs: { disabled: _vm.disabled },
          model: {
            value: _vm.newValue,
            callback: function($$v) {
              _vm.newValue = $$v
            },
            expression: "newValue"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }